import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const Headshots = ({ slice }) => {
  return (
    <section className='component-headshots mx-auto max-w-screen-xl p-6'>
      <div className='rounded bg-gradient-to-r from-blue-900 to-sky-600 py-10 px-8 text-blue-50'>
        {slice.primary.headshot_title && <h2 className='mb-8 text-center text-3xl text-blue-50 lg:mb-16'>{slice.primary.headshot_title.text}</h2>}
        <ul className='grid gap-8 sm:grid-cols-2 md:grid-cols-3 md:gap-16 lg:mb-8 lg:px-16'>
          {slice.items.map((individual, index) => {
            return (
              <div className='mx-auto grid w-full grid-cols-2 gap-4 md:w-48 md:grid-cols-1 md:gap-2 md:text-center' key={`individual-${index}`}>
                {individual.image.gatsbyImageData && (
                  <GatsbyImage image={individual.image.gatsbyImageData} className='relative z-10 overflow-hidden rounded-full border-4 border-orange-500' alt={individual.image.alt || ''} />
                )}
                <div className='flex flex-col justify-center md:-mx-8'>
                  <div className='mt-1 text-2xl font-medium'>{individual.name}</div>
                  <div className='text-sm uppercase'>{individual.role}</div>
                </div>
              </div>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Headshots
